import React, { useState, useRef, useEffect, useContext } from "react";
import { Carousel, Button, Modal } from "antd";
import { FaHeart } from "react-icons/fa"; // Import FontAwesome Heart icon
import { useHistory } from "react-router-dom";
import arrowleft from "../../Images/arrowleft.png";
import arrowright from "../../Images/arrowright.png";
import prod1 from "../../Images/prod1.png";
import star from "../../Images/star.png";

import card1 from "../../Images/card1.png";
import axios from "axios";
import Luxuryperfume3 from "../../Images/Luxuryperfume3.png";
import ArrowDown from "../../Images/ArrowDown.png";
import CloseImg from "../../Images/CloseImg.png";
import plusImage1 from "../../Images/plusImage1.png";
import minusImage1 from "../../Images/minusImage1.png";
import shoppingbag from "../../Images/shoppingbag.png";
import deleteImage from "../../Images/deleteImage.png";
import { AppContext, useAppContext } from "./../../AppContext";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import AllCategoriesOpenMobileDrawer from "./AllCategoriesOpenMobileDrawer";
import AllCategoriesCartDialog from "./AllCategoriesCartDialog";
import Rating from "@mui/material/Rating";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { useTranslation } from "react-i18next";
import { MyDomain } from "../../App";
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    width:
      window.innerWidth <= 1920
        ? "90%"
        : window.innerWidth <= 2560
        ? "70%"
        : window.innerWidth <= 3840
        ? "60%"
        : "50%", // Full width minus 5% padding on each side
    margin: "0 auto", // Center the modal horizontally
    maxWidth: "none", // Disable the default max width
    borderRadius: 0,
  },
}));

export default function AllCategoriesRecentlyViewed() {
  const { t, i18n } = useTranslation();
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const { setOpenLoginPopOver, OpenLoginPopOver } = useAppContext();
  const [MobileOpenDrawerOBJ, setMobileOpenDrawerOBJ] = useState([]);
  const [OpenMobileDrawer, setOpenMobileDrawer] = React.useState(false);

  const handleChildFunction1 = (dataFromSource) => {
    setMobileOpenDrawerOBJ(dataFromSource);
  };
  const [productDropDowns1ForMobile, setproductDropDowns1ForMobile] = useState(
    []
  );

  const OpenMobileDrawerFunc = (theOBJ) => {
    //const newData = `Data from parent at ${new Date().toLocaleTimeString()}`;
    setMobileOpenDrawerOBJ(theOBJ);
    //handleChildFunction1(true);
    setOpenMobileDrawer(true);
  };

  const CloseMobileDrawerFromChildFunc = (dataFromSource) => {
    setOpenMobileDrawer(false);
  };

  const CreateProduct4 = (event) => {
    console.log("its here 2");

    setCartData([]);
    //event.preventDefault();
    const data = {
      UserId: user?.userId,
      IdOfProduct: event, //OBJOfProductChoosed?.id,
      AmountOfProduct: 1,
    };
    axios
      .post(`${MyDomain}Cart/AddProductToCart`, data) // replace with your API URL
      .then((response) => {
        //setResponseMessage("Data submitted successfully!");
        setCartData(response.data);
        setCartAmount(response.data.userCart.length);
        handleClickOpen(response.data);
      })
      .catch((error) => {
        //setResponseMessage("Error submitting data.");
        console.log(error);
      });
  };
  const [selectedOption, setSelectedOption] = useState(""); // Default selected option

  const [MyWidth, setMyWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setMyWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const user = JSON.parse(localStorage.getItem("user"));

  const handleDivClick2 = (CategoryName, ProductId) => {
    scrollToTop();

    history.push(`/product/${ProductId}`);
  };

  const CreateProduct2 = (IdOfProduct) => {
    const data = {
      UserId: user?.userId,
      IdOfProduct: IdOfProduct,
      AmountOfProduct: 1, // Default to adding 1 product to the cart
    };

    axios
      .post(`${MyDomain}Cart/AddProductToCart`, data) // API URL for adding products to the cart
      .then((response) => {
        // Update cart data in state
        setCartData(response.data);

        const userCart = response.data?.userCart || [];
        const products = response.data?.products || [];

        // Calculate total price with discount logic
        const totalPrice = userCart.reduce((accumulator, cartItem) => {
          const product = products.find((p) => p.id === cartItem.idOfProduct);
          if (product) {
            const { price, discount, theDeal } = product;
            const { amountOfProduct } = cartItem;
            let total = 0;

            if (theDeal === 1) {
              // Apply discount to all items
              total += price * (1 - discount / 100) * amountOfProduct;
            } else {
              // Apply discount only to every nth item
              for (let i = 1; i <= amountOfProduct; i++) {
                if (i % theDeal === 0) {
                  total += price * (1 - discount / 100);
                } else {
                  total += price;
                }
              }
            }
            return accumulator + total;
          }
          return accumulator; // If no matching product, skip
        }, 0);
        setSaveTotalPrice(totalPrice);
        setCartAmount(response.data.userCart.length);
      })
      .catch((error) => {
        console.log("Error adding product to cart:", error);
      });
  };

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [ProductChoosed, setProductChoosed] = useState([]);
  const [ImageChoosed, setImageChoosed] = useState("");
  const [ProductChoosed2, setProductChoosed2] = useState(0);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [OBJOfProductChoosed, setOBJOfProductChoosed] = useState({});

  const CreateProduct3 = (event) => {
    setCartData([]);
    //event.preventDefault();
    const data = {
      UserId: user?.userId,
      IdOfProduct: OBJOfProductChoosed?.id,
      AmountOfProduct: 1,
    };
    axios
      .post(`${MyDomain}Cart/AddProductToCart`, data) // replace with your API URL
      .then((response) => {
        setCartData(response.data);
        setCartAmount(response.data.userCart.length);
        handleClickOpen(response.data);
      })
      .catch((error) => {
        //setResponseMessage("Error submitting data.");
        console.log(error);
      });
  };
  useEffect(() => {
    // Fetch data when the component mounts
    axios
      .get(`${MyDomain}Users/GetUsers`) // Replace with your API endpoint
      .then((response) => {
        setData(response.data); // Store the data
        setLoading(false); // Set loading to false
      })
      .catch((error) => {
        setError(error); // Handle any errors
        setLoading(false);
      });
  }, []); // Empty dependency array ensures this effect runs once on mount

  const [ProductsData, setProductsData] = useState([]);
  const [ProductsDataWithoutDub, setProductsDataWithoutDub] = useState([]);
  const [ProductsLoading, setProductsLoading] = useState(true);
  const [ProductsError, setProductsError] = useState(null);

  useEffect(() => {
    const data = {
      UserId: user?.userId,
    };
    // Fetch data when the component mounts
    axios
      .post(`${MyDomain}Recently/GetRecentlyByUserId`, data) // Replace with your API endpoint
      .then((response) => {
        setProductsData(response.data); // Store the data
        setProductsLoading(false); // Set loading to false
        const newArray = response.data.filter(
          (item) => item.id === item.productId
        );
        setProductsDataWithoutDub(newArray);
      })
      .catch((error) => {
        setProductsError(error); // Handle any errors
        setProductsLoading(false);
      });
  }, []); // Empty dependency array ensures this effect runs once on mount

  const history = useHistory();

  const [currentSlide, setCurrentSlide] = useState(0);
  const carouselRef = React.createRef();

  const next = () => {
    carouselRef.current.next();
  };

  const prev = () => {
    carouselRef.current.prev();
  };

  const handleBeforeChange = (from, to) => {
    setCurrentSlide(to);
  };

  const wrapperRef = useRef();

  ///

  const [currentSlide2, setCurrentSlide2] = useState(0);
  const carouselRef2 = React.createRef();

  ///

  // Function to group products into chunks of specified size
  const chunkArray = (arr, size) => {
    const result = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
  };
  const chunkArray2 = (array, size) => {
    if (!Array.isArray(array) || array.length === 0) {
      return []; // Return an empty array if input is not a valid array
    }

    const result = [];
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }
    return result;
  };
  const [RecommendedProductsData, setRecommendedProductsData] = useState([]);

  const GetRecommendedProducts = () => {
    setRecommendedProductsData([]);

    const data = {
      UserId: user?.userId,
    };
    axios
      .post(`${MyDomain}RecommendedProducts/GetRecommendedProductsById`, data)
      .then((response) => {
        setRecommendedProductsData(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };
  useEffect(() => {
    GetRecommendedProducts();
  }, []);
  //const numItemsPerSlide = 5; // Change this to 4 if you want 4 items per slide
  const numItemsPerSlide = MyWidth <= 1024 ? 2 : MyWidth <= 1440 ? 4 : 5; // Change this to 4 if you want 4 items per slide

  const slides = chunkArray(ProductsDataWithoutDub, numItemsPerSlide); // Grouping products into chunks of 4

  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);

  useEffect(() => {
    if (MyWidth > 1024) {
      document.body.style.overflowX = "hidden";
      // Target the .slick-list element within the carousel wrapper div
      const slickList = wrapperRef.current?.querySelector(".slick-list");
      if (slickList) {
        slickList.style.overflow = "visible";
        slickList.style.clipPath = "inset(0px 0px -150px 0px)";
        //slickList.style.paddingBottom = "50px"; // Adjust padding as needed to control dropdown overflow at the bottom
      }
      // Cleanup function to reset body style on component unmount
      return () => {
        document.body.style.overflowX = "";
      };
    }
  }, []);
  const handleOpenDialog = () => {
    setMyOpen(true);
  };

  const handleClickOpen = async (NewData) => {
    setCartData(NewData);
    const userCart = NewData?.userCart || [];
    const products = NewData?.products || [];
    // Safely calculate total price with discount logic
    const totalPrice = userCart.reduce((accumulator, cartItem) => {
      const product = products.find((p) => p.id === cartItem.idOfProduct);
      if (product) {
        const { price } = product;
        const { amountOfProduct } = cartItem;
        let total = 0;

        if (product.theDeal === 1) {
          // Apply discount to all items
          total += price * (1 - product.discount / 100) * amountOfProduct;
        } else {
          // Apply discount only to every nth item
          for (let i = 1; i <= amountOfProduct; i++) {
            if (i % product.theDeal === 0) {
              total += price * (1 - product.discount / 100);
            } else {
              total += price;
            }
          }
        }

        // Add the total for this product to the accumulator
        return accumulator + total;
      }
      return accumulator; // If no matching product, skip
    }, 0);

    setSaveTotalPrice(totalPrice);
    handleOpenDialog();
    //setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setOpen2(false);
  };
  const handleClose2 = () => {
    setOpen2(false);
    setProductChoosed([]);
    setProductChoosed2(0);
    setOBJOfProductChoosed({});
  };
  const [SaveTotalPrice, setSaveTotalPrice] = useState(0);
  const { CartAmount, setCartAmount } = useContext(AppContext);
  const [hoverStates, setHoverStates] = useState({}); // Store hover states for each ID
  const handleMouseEnter = (id) => {
    setHoverStates((prev) => ({ ...prev, [id]: true }));
  };

  const handleMouseLeave = (id) => {
    setHoverStates((prev) => ({ ...prev, [id]: false }));
  };
  // Close dropdown if clicked outside
  const [CartData, setCartData] = useState([]);

  useEffect(() => {
    setCartData([]);
    //event.preventDefault();
    const data = {
      UserId: user?.userId,
    };

    axios
      .post(`${MyDomain}Cart/GetUserCart`, data) // replace with your API URL
      .then((response) => {
        setCartData(response.data);
      })
      .catch((err) => {
        //setResponseMessage("Error submitting data.");
        console.log(err.response.data);
      });
  }, []);
  const handleDivClick1 = (CategoryName) => {
    history.push(`/${CategoryName}`);
  };

  const calculateTotalPrice = (price, amount, discount, discountOnEvery) => {
    let total = 0;

    for (let i = 1; i <= amount; i++) {
      if (i % discountOnEvery === 0) {
        // Apply discount to every 'discountOnEvery' item
        total += price * (1 - discount / 100);
      } else {
        // Add full price for non-discounted items
        total += price;
      }
    }

    // Format the total to show decimals only when needed
    const formattedTotal = Number.isInteger(total)
      ? total.toString()
      : parseFloat(total.toFixed(2));

    return formattedTotal;
  };

  const MyModal2 = () => {
    return (
      <>
        <React.Fragment>
          {/* <Button variant="outlined" onClick={handleClickOpen}>
            Open dialog
          </Button> */}
          <BootstrapDialog
            onClose={handleClose2}
            aria-labelledby="customized-dialog-title"
            open={open2}
            fullWidth
            maxWidth={false} // Disable Material-UI's default width settings
          >
            <DialogTitle
              sx={{ m: 0, p: 2 }}
              id="customized-dialog-title"
            ></DialogTitle>
            <IconButton
              aria-label="close"
              onClick={handleClose2}
              sx={(theme) => ({
                position: "absolute",
                right: 8,
                top: 8,
                color: theme.palette.grey[500],
              })}
            >
              <CloseIcon />
            </IconButton>
            <div style={{}}>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    width: "35%",
                    height: "calc(75vh - 55px)",
                    paddingTop: "1%",
                    paddingBottom: "1%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={ImageChoosed}
                    style={{
                      width: "80%",
                      //minWidth: "80%",
                      //height: "80%",
                      //contain: "content",
                    }}
                  />
                </div>
                <div
                  style={{
                    width: "55%",
                    height: "calc(75vh - 55px)",
                    display: "flex",
                    //backgroundColor: "red",
                    paddingTop: "1%",
                    paddingBottom: "1%",
                    flexDirection: "column",
                  }}
                >
                  <div style={{ display: "flex" }}>
                    <p
                      style={{
                        margin: 0,
                        fontWeight: "500",
                        fontSize: 18,
                        paddingBottom: 40,
                      }}
                    >
                      {ProductChoosed[0]?.name}
                    </p>
                  </div>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(4, 1fr)",
                      //gap: "10px",
                      height: "80%",
                    }}
                  >
                    {ProductChoosed.map((product, index) => (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          width: "100%",
                          height: 100,
                          paddingTop: "5%",
                          paddingLeft: "5%",
                          border:
                            ProductChoosed2 === index
                              ? "1px solid black"
                              : hoveredIndex === index
                              ? "1px solid black"
                              : "1px solid #ccc",
                          cursor: "pointer",
                          //transition: "border 0.2s ease-in-out",
                          flexDirection: "column",
                        }}
                        onClick={() => {
                          setImageChoosed(product?.image);
                          setProductChoosed2(index);
                          setOBJOfProductChoosed(ProductChoosed[index]);
                        }}
                        onMouseEnter={() => setHoveredIndex(index)}
                        onMouseLeave={() => setHoveredIndex(null)}
                      >
                        <img
                          src={product?.image}
                          style={{
                            width: 30,
                            height: 30,
                          }}
                        />
                        <p style={{ margin: 0 }}>{product?.dropDown}</p>
                      </div>
                    ))}
                  </div>
                  <div
                    style={{
                      height: "20%",
                      width: "100%",
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                    }}
                  >
                    <p style={{ margin: 0 }}>
                      <a
                        style={{
                          fontSize: 15,
                        }}
                      >
                        {OBJOfProductChoosed?.discount === 0 ? (
                          <></>
                        ) : (
                          <>
                            {OBJOfProductChoosed?.theDeal === 1 ? (
                              <>
                                <a
                                  style={{
                                    backgroundColor: "#6b21a8",
                                    color: "white",
                                    margin: 0,
                                    marginBottom: 5,
                                    paddingLeft: 5,
                                    paddingRight: 5,
                                    fontSize: 15,
                                  }}
                                >
                                  -{OBJOfProductChoosed?.discount}%
                                </a>
                                <a
                                  style={{
                                    fontSize: 12,
                                  }}
                                >
                                  &nbsp;
                                </a>
                              </>
                            ) : (
                              <>
                                <a
                                  style={{
                                    backgroundColor: "#6b21a8",
                                    color: "white",
                                    fontSize: 12,
                                    paddingLeft: 5,
                                    paddingRight: 5,
                                  }}
                                >
                                  Buy 2 pcs to get -
                                  {OBJOfProductChoosed?.discount}% off every{" "}
                                  {OBJOfProductChoosed?.theDeal}
                                  {OBJOfProductChoosed?.theDeal === 2
                                    ? "nd"
                                    : "th"}{" "}
                                  item
                                </a>
                              </>
                            )}
                          </>
                        )}
                      </a>
                    </p>
                    &nbsp; &nbsp;
                    {OBJOfProductChoosed?.discount === 0 ? (
                      <></>
                    ) : (
                      <>
                        {OBJOfProductChoosed?.theDeal === 1 ? (
                          <p
                            style={{
                              margin: 0,

                              color:
                                OBJOfProductChoosed?.discount === 0 ||
                                OBJOfProductChoosed?.theDeal === 2
                                  ? ""
                                  : "red",
                            }}
                          >
                            {calculateTotalPrice(
                              OBJOfProductChoosed?.price,
                              1,
                              OBJOfProductChoosed?.discount,
                              1
                            )}
                            &nbsp; &nbsp;
                          </p>
                        ) : (
                          <></>
                        )}
                      </>
                    )}
                    <a
                      style={{
                        textDecoration:
                          OBJOfProductChoosed?.discount === 0 ||
                          OBJOfProductChoosed?.theDeal === 2
                            ? "none"
                            : "line-through",
                        fontSize: 15,
                      }}
                    >
                      ₪{OBJOfProductChoosed?.price}
                    </a>
                    {/* <p style={{ margin: 0 }}>
                      {" "}
                      ₪{OBJOfProductChoosed?.price}&nbsp; &nbsp;
                    </p> */}
                    &nbsp; &nbsp;
                    <button
                      style={{
                        backgroundColor: "#27272a",
                        color: "#fff",
                        border: "none",
                        padding: "10px 20px",
                        cursor: "pointer",
                        fontSize: "16px",
                        width: 200,
                        height: 50,
                      }}
                      onClick={() => {
                        CreateProduct3();
                      }}
                    >
                      {t("profile.Buy")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </BootstrapDialog>
        </React.Fragment>
      </>
    );
  };

  const [MyOpen, setMyOpen] = React.useState(false);
  const handleCloseDialog = () => {
    setMyOpen(false);
  };
  return (
    <div
      style={{
        position: "relative",
        paddingTop: "100px",
        paddingLeft: MyWidth <= 1024 ? "2%" : "0%",
        paddingRight: MyWidth <= 1024 ? "2%" : "0%",
        fontFamily: "Droid Arabic Kufi, sans-serif",
      }}
    >
      {MyModal2()}
      <AllCategoriesCartDialog
        MyOpen={MyOpen}
        onClose={handleCloseDialog}
        CartData={CartData}
        MySaveTotalPrice={SaveTotalPrice}
        onCreateProduct2={CreateProduct2}
        handleDivClick2={handleDivClick2}
        MyRecommendedProductsData={RecommendedProductsData}
      />
      <AppContext.Provider
        value={{
          MobileOpenDrawerOBJ,
          handleChildFunction1,
          OpenMobileDrawer,
          CloseMobileDrawerFromChildFunc,
          CreateProduct4,
        }}
      >
        <AllCategoriesOpenMobileDrawer openDrawer2={true} />
      </AppContext.Provider>
      {/* {Modal1()} */}
      <div
        style={{
          justifyContent: "space-between",
          alignItems: "center",
          display: "flex",
          paddingBottom: 20,
        }}
      >
        {MyWidth <= 1024 ? (
          <></>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <a style={{ fontWeight: "500", fontSize: 25 }}>{"         "}</a>
          </div>
        )}

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <a style={{ fontWeight: "500", fontSize: MyWidth <= 1024 ? 16 : 25 }}>
            {t("profile.Recentlyviewed")}
          </a>
        </div>

        <div style={{ alignItems: "center", display: "flex" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              paddingRight: 30,
            }}
            onClick={prev}
          >
            <img
              src={arrowleft}
              style={{
                width: 35,
                height: 35,
                opacity: currentSlide === 0 ? 0.3 : 1,
                cursor: currentSlide === 0 ? "" : "pointer",
              }}
            />
          </div>
          <div
            style={{
              //backgroundColor: "#fafafa",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={next}
          >
            <img
              src={arrowright}
              style={{
                width: 35,
                height: 35,
                opacity: currentSlide === slides.length - 1 ? 0.3 : 1,
                cursor: currentSlide === slides.length - 1 ? "" : "pointer",
              }}
            />
          </div>
        </div>
      </div>
      <div ref={wrapperRef}>
        <Carousel
          arrows={false}
          infinite={false}
          ref={carouselRef}
          beforeChange={handleBeforeChange}
          dots={false}
        >
          {slides.map((slide, index) => (
            <div>
              <div
                key={index}
                style={{
                  display: "flex",
                  //justifyContent: "space-between",
                  justifyContent: "flex-start",
                  width: "100%",
                  direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
                }}
              >
                {slide.map((image, imgIndex) => {
                  const globalIndex = index * numItemsPerSlide + imgIndex;
                  return (
                    <div
                      style={{
                        marginRight:
                          i18n.resolvedLanguage === "en"
                            ? (imgIndex + 1) % numItemsPerSlide === 0
                              ? 0
                              : 20
                            : 0,

                        marginLeft:
                          i18n.resolvedLanguage === "en"
                            ? 0
                            : (imgIndex + 1) % numItemsPerSlide === 0
                            ? 0
                            : 20,
                        //width: "19.5%",
                        width: "100%",
                      }}
                    >
                      <ProductCard
                        key={globalIndex}
                        id={ProductsDataWithoutDub[globalIndex].id}
                        productId={
                          ProductsDataWithoutDub[globalIndex].productId
                        }
                        image={ProductsDataWithoutDub[globalIndex].image}
                        mainImage={
                          ProductsDataWithoutDub[globalIndex].mainImage
                        }
                        title={ProductsDataWithoutDub[globalIndex].name} //"Molinard Osmanthus"
                        subtitle={
                          ProductsDataWithoutDub[globalIndex].productType
                        } //"Eau de Parfum"
                        price={ProductsDataWithoutDub[globalIndex].price} //"₪ 19"
                        discount={ProductsDataWithoutDub[globalIndex].discount}
                        deals={ProductsDataWithoutDub[globalIndex].deals}
                        thedeal={ProductsDataWithoutDub[globalIndex].theDeal}
                        theOBJ={ProductsDataWithoutDub[globalIndex]}
                        news={ProductsDataWithoutDub[globalIndex].news}
                        dropDown={ProductsDataWithoutDub[globalIndex].dropDown}
                        reviews={ProductsDataWithoutDub[globalIndex].reviews}
                        priceinsteadof={
                          ProductsDataWithoutDub[globalIndex].priceInsteadOf
                        }

                        //onHeartClick={() => handleHeartClick(globalIndex)} // Handle heart click
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  );

  function ProductCard({
    id,
    productId,
    image,
    mainImage,
    title,
    subtitle,
    price: initialPrice,
    discount: initialdiscount,
    deals,
    thedeal: initialthedeal,
    isHeartClicked,
    onHeartClick,
    theOBJ,
    news,
    dropDown,
    reviews,
    priceinsteadof: initialpriceinsteadof,
  }) {
    const [isDivHovered, setIsDivHovered] = useState(false);
    const [isHeartHovered, setIsHeartHovered] = useState(false);
    const selectRef = useRef(null);
    const handleBlur = () => {
      selectRef.current.blur();
    };
    //DropDown
    const [price, setPrice] = useState(initialPrice);
    const [priceInsteadOf, setPriceInsteadOf] = useState(initialpriceinsteadof);
    const [hoverPriceInsteadOf, setHoverPriceInsteadOf] = useState(null); // Temporary price for hover

    const [discount, setDiscount] = useState(
      initialdiscount === 0 ? null : price - (price * initialdiscount) / 100
    );
    const [thedeal, setThedeal] = useState(initialthedeal);
    const [hoverThedeal, setHoverThedeal] = useState(null); // Temporary price for hover

    const [hoverDiscount, setHoverDiscount] = useState(null); // Temporary price for hover
    const [hoverPrice, setHoverPrice] = useState(null); // Temporary price for hover
    const [theDiscount, setTheDiscount] = useState(initialdiscount);
    const [hoverTheDiscount, sethoverTheDiscount] = useState(null);
    const [IdOfProduct, setIdOfProduct] = useState(id);
    const [CartData, setCartData] = useState([]);

    const [isOpen, setIsOpen] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalOpen2, setIsModalOpen2] = useState(false);

    const averageRating = Math.floor(
      reviews.reduce((sum, item) => sum + item.rating, 0) / reviews.length
    );
    const [ReviewsProduct, setReviewsProduct] = useState(averageRating);
    const [NumberUsersReview, setNumberUsersReview] = useState(reviews.length);
    const [ListOfUsersReview, setListOfUsersReview] = useState(reviews);

    const showModal = () => {
      setIsModalOpen(true);
    };
    const showModal2 = () => {
      setIsModalOpen2(true);
    };

    const [selectedOption, setSelectedOption] = useState(dropDown); // Default selected option
    const dropdownRef = useRef(null); // Reference to the dropdown
    const newArray1 = ProductsData.filter(
      (item) => item.productId === productId
    );

    // Extract only the productId values
    const productDropDowns = newArray1.map((item) => item.dropDown);

    const productDropDowns1 = newArray1.map((item) => item);

    const [clickedHearts, setClickedHearts] = useState(
      Array(ProductsData.length).fill(false)
    );

    const toggleDropdown = () => {
      setIsOpen(!isOpen);
    };

    const handleOptionClick = (option) => {
      setSelectedOption(option);
      setIsOpen(false); // Close the dropdown after selecting
    };

    const CreateProduct = (event) => {
      setCartData([]);
      //event.preventDefault();
      const data = {
        UserId: user?.userId,
        IdOfProduct: IdOfProduct,
        AmountOfProduct: 1,
      };
      axios
        .post(`${MyDomain}Cart/AddProductToCart`, data) // replace with your API URL
        .then((response) => {
          //setResponseMessage("Data submitted successfully!");
          console.log(response.data);
          setCartData(response.data);
          setCartAmount(response.data.userCart.length);
          handleClickOpen(response.data);
        })
        .catch((error) => {
          //setResponseMessage("Error submitting data.");
          console.log(error);
        });
    };

    const { WishList, setWishList } = useAppContext();

    const AddProductToWishList = async (event) => {
      const data = {
        ProductId: IdOfProduct,
        UserId: user?.userId,
      };
      axios
        .post(`${MyDomain}WishList/AddProductToWishList`, data) // replace with your API URL
        .then((response) => {
          setWishList(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    };
    const DeleteFromWishList = async (TheId) => {
      axios
        .delete(`${MyDomain}WishList/DeleteFromWishList`, {
          data: { ProductId: IdOfProduct, UserId: user?.userId },
        })
        .then((response) => {
          setWishList(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    };

    const toggleWishlist = async () => {
      const productExists = WishList.some(
        (item) => item.productId === IdOfProduct
      );
      if (productExists) {
        await DeleteFromWishList();
      } else {
        // If product does not exist, add it
        await AddProductToWishList();
      }
    };
    // State to track which products have clicked hearts
    const { CartAmount, setCartAmount } = useContext(AppContext);

    return (
      <div
        onMouseEnter={() => {
          MyWidth <= 1024 ? <></> : setIsDivHovered(true);
        }}
        onMouseLeave={() => {
          MyWidth <= 1024 ? <></> : setIsDivHovered(false);
          //handleBlur(false);
        }}
        style={{
          fontFamily: "Droid Arabic Kufi, sans-serif",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            backgroundColor: "#fafafa",
          }}
        >
          <div
            style={{
              margin: 0,
              backgroundColor: "#27272a",
              transition: "color 0.3s ease",
              cursor: "pointer",
              height: MyWidth <= 1024 ? "50%" : "100%",
            }}
          >
            <p
              style={{
                margin: 0,
                fontSize: "10px",
                color: "white",
                padding: deals !== "" ? 5 : 0,
                paddingLeft: deals !== "" ? 10 : 0,
                paddingRight: deals !== "" ? 10 : 0,
                fontWeight: "bold",
              }}
            >
              {/* {deals}{" "} */}
              {deals === "ORIGINAL" ? (
                <>{t("profile.original")}</>
              ) : deals === "MASTER" ? (
                <>{t("profile.master")}</>
              ) : (
                ""
              )}
            </p>
          </div>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div
              style={{
                //backgroundColor: isDivHovered || isHeartHovered ? "white" : "",
                display: "flex",
                // position: "absolute",
                // top: "10px",
                // right: "10px",
                padding: 6,
                borderRadius: 50,
              }}
            >
              {/* Heart icon changes color based on hover and click */}
              <FaHeart
                onMouseEnter={() => setIsHeartHovered(true)}
                onMouseLeave={() => setIsHeartHovered(false)}
                onClick={() => {
                  if (user === null) {
                    setOpenLoginPopOver(true);
                    window.scrollTo({
                      top: 0,
                      behavior: "smooth",
                    });
                  } else {
                    toggleWishlist();
                    const updatedClickedHearts = [...clickedHearts];
                    updatedClickedHearts[IdOfProduct] =
                      !updatedClickedHearts[IdOfProduct]; // Toggle heart state
                    setClickedHearts(updatedClickedHearts); // Update the heart clicked state
                  }
                }} // Handle heart click
                //WishListData.find((obj) => obj.productId === id)
                style={{
                  fontSize: "18px",
                  color:
                    MyWidth <= 1024
                      ? WishList.some((item) => item.productId === IdOfProduct)
                        ? "#4f46e5"
                        : "#ccc"
                      : isHeartHovered
                      ? "#4f46e5" // Red when hovering over the heart
                      : WishList.some((item) => item.productId === IdOfProduct)
                      ? "#4f46e5"
                      : "#ccc", // Gray when not hovered or clicked
                  transition: "color 0.3s ease",
                  opacity:
                    MyWidth <= 1024
                      ? WishList.some((item) => item.productId === IdOfProduct)
                        ? 1
                        : 1
                      : isDivHovered ||
                        isHeartHovered ||
                        WishList.some((item) => item.productId === IdOfProduct)
                      ? 1
                      : 0,
                  cursor: "pointer",
                }}
              />
            </div>
            {MyWidth <= 1024 ? (
              <div
                style={{
                  display: "flex",
                  padding: 6,
                  borderRadius: 50,
                  cursor: "pointer",
                }}
                onClick={() => {
                  OpenMobileDrawerFunc(productDropDowns1);
                }}
              >
                <img
                  src={shoppingbag}
                  alt={{}}
                  style={{
                    maxHeight: 20,
                    maxWidth: 20,
                    objectFit: "contain",
                  }}
                />
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
        <div
          style={{
            backgroundColor: "#fafafa",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            //flexGrow: 1,
            //height: "350px", // Ensure consistent height
            cursor: "pointer",
            flexDirection: "column",
          }}
          onClick={() => {
            handleDivClick2("product", id);
          }}
        >
          <img
            src={image}
            alt={title}
            style={{
              // maxHeight: "100%",
              // maxWidth: "100%",
              // objectFit: "contain",
              height: MyWidth <= 1024 ? 150 : 300,
              width: "100%",
              objectFit: "contain",
            }}
          />
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "flex-start",
              height: "30px", // Set a fixed height
              alignItems: "center",
            }}
          >
            {news !== null && (
              <a
                style={{
                  fontSize: 12,
                  backgroundColor: "#6b21a8",
                  padding: 3,
                  margin: 5,
                  color: "white",
                  paddingLeft: 8,
                  paddingRight: 8,
                }}
              >
                {i18n.language === "en"
                  ? news?.typeOfferName
                  : i18n.language === "ar"
                  ? news?.typeOfferNameAr
                  : i18n.language === "he"
                  ? news?.typeOfferNameHe
                  : news?.typeOfferName}
              </a>
            )}
          </div>
        </div>
        <p style={{ fontSize: 18, marginBottom: 1 }}>{title}</p>
        <p style={{ fontSize: 15, opacity: 0.5 }}>{subtitle}</p>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          {NumberUsersReview === 0 ? (
            <>
              <Rating
                name="read-only"
                value={ReviewsProduct}
                readOnly
                sx={{
                  // Make stars bigger
                  fontSize: "0.75rem", // Adjust size (e.g., 1.5rem, 2rem, etc.)

                  // Add space between stars
                  "& .MuiRating-icon": {
                    color: "black", // Black stars
                    paddingRight: "0 2px", // Adjust spacing (e.g., 0 8px for more space)
                    //paddingTop: 1,
                    opacity: 0.2,
                  },

                  // Ensure filled/hover stars are also black
                  "& .MuiRating-iconFilled": {
                    color: "black",
                  },
                  "& .MuiRating-iconHover": {
                    color: "black",
                  },
                }}
              />
            </>
          ) : (
            <>
              {" "}
              <Rating
                name="read-only"
                value={ReviewsProduct}
                readOnly
                sx={{
                  // Make stars bigger
                  fontSize: "0.75rem", // Adjust size (e.g., 1.5rem, 2rem, etc.)

                  // Add space between stars
                  "& .MuiRating-icon": {
                    color: "black", // Black stars
                    paddingRight: "0 2px", // Adjust spacing (e.g., 0 8px for more space)
                    //paddingTop: 1,
                  },

                  // Ensure filled/hover stars are also black
                  "& .MuiRating-iconFilled": {
                    color: "black",
                  },
                  "& .MuiRating-iconHover": {
                    color: "black",
                  },
                }}
              />
            </>
          )}
          {NumberUsersReview !== 0 ? (
            <a style={{ fontSize: 14, opacity: 0.5 }}>
              &nbsp;{NumberUsersReview}
            </a>
          ) : (
            <>
              <a>&nbsp;</a>
            </>
          )}
        </div>
        <div
          style={{
            flexDirection: "row",
            display: "flex",
            justifyContent: "space-between",
            height: 50,
          }}
        >
          <div
            style={{
              flexDirection: "row",
              display: "flex",
            }}
          >
            <p>
              {hoverDiscount !== null ? (
                hoverDiscount?.toFixed(2) === hoverPrice?.toFixed(2) ? (
                  ""
                ) : (
                  <>
                    {hoverThedeal === 1 ? (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <a
                          style={{
                            color: "red",
                            fontSize: 15,
                          }}
                        >
                          {hoverTheDiscount === 0 ? "" : <>₪</>}
                          {hoverDiscount?.toFixed(2)}
                          {hoverTheDiscount === 0 ? "" : <>&nbsp; &nbsp;</>}
                        </a>
                      </div>
                    ) : (
                      <></>
                    )}
                  </>
                )
              ) : discount?.toFixed(2) === price?.toFixed(2) ? (
                ""
              ) : (
                <>
                  {thedeal === 1 ? (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <a style={{ color: "red", fontSize: 15 }}>
                        {theDiscount === 0 ? "" : <>₪</>}
                        {discount?.toFixed(2)}
                        {theDiscount === 0 ? "" : <>&nbsp; &nbsp;</>}
                      </a>
                    </div>
                  ) : (
                    <></>
                  )}
                </>
              )}
            </p>
            <p>
              {hoverPrice !== null ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  {hoverPriceInsteadOf === 0 ? (
                    <>
                      <a
                        style={{
                          textDecoration:
                            hoverTheDiscount === 0 || hoverThedeal === 2
                              ? "none"
                              : "line-through",
                          fontSize: 15,
                        }}
                      >
                        ₪{hoverPrice}
                      </a>
                    </>
                  ) : (
                    <>
                      <a
                        style={{
                          textDecoration:
                            hoverTheDiscount === 0 || hoverThedeal === 2
                              ? "none"
                              : "line-through",
                          fontSize: 15,
                        }}
                      >
                        <a
                          style={{
                            margin: 0,
                            color: "red",
                            textDecoration: "line-through",
                            fontSize: 15,
                          }}
                        >
                          ₪{hoverPrice}
                        </a>
                        &nbsp;&nbsp;
                        <a
                          style={{
                            textDecoration:
                              hoverTheDiscount === 0 || hoverThedeal === 2
                                ? "none"
                                : "line-through",
                            fontSize: 15,
                          }}
                        >
                          ₪{hoverPriceInsteadOf}
                        </a>
                      </a>
                    </>
                  )}
                </div>
              ) : (
                <>
                  {priceInsteadOf === 0 ? (
                    <a
                      style={{
                        textDecoration:
                          theDiscount === 0 || thedeal === 2
                            ? "none"
                            : "line-through",
                        fontSize: 15,
                      }}
                    >
                      ₪{price}
                    </a>
                  ) : (
                    <>
                      <a
                        style={{
                          margin: 0,
                          color: "red",
                          textDecoration: "line-through",
                          fontSize: 15,
                        }}
                      >
                        ₪{price}
                      </a>
                      &nbsp;&nbsp;
                      <a
                        style={{
                          textDecoration:
                            theDiscount === 0 || thedeal === 2
                              ? "none"
                              : "line-through",
                          fontSize: 15,
                        }}
                      >
                        ₪{priceInsteadOf}
                      </a>
                    </>
                  )}
                </>
              )}
            </p>
          </div>
          <div>
            <a>
              {hoverTheDiscount !== null ? (
                hoverTheDiscount === 0 ? (
                  ""
                ) : (
                  <a>
                    {hoverThedeal === 1 ? (
                      <>
                        <a
                          style={{
                            backgroundColor: "#6b21a8",
                            color: "white",
                            fontSize: 12,
                            paddingLeft: 5,
                            paddingRight: 5,
                          }}
                        >
                          -{hoverTheDiscount}%
                        </a>
                      </>
                    ) : (
                      <></>
                    )}
                  </a>
                )
              ) : theDiscount === 0 ? (
                ""
              ) : (
                <a>
                  {thedeal === 1 ? (
                    <>
                      {" "}
                      <a
                        style={{
                          backgroundColor: "#6b21a8",
                          color: "white",
                          paddingLeft: 5,
                          paddingRight: 5,
                          fontSize: 15,
                        }}
                      >
                        -{theDiscount}%
                      </a>{" "}
                    </>
                  ) : (
                    <></>
                  )}
                </a>
              )}
            </a>
          </div>
        </div>
        <div
          style={{
            backgroundColor: "#fff",
            padding: "1px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            transition: "transform 0.3s ease, opacity 0.3s ease",
            transform: isDivHovered ? "translateY(0)" : "translateY(-100%)", // Slide from top to bottom
            opacity: isDivHovered ? 1 : 0, // Fade in/out on hover
            height: "50px",
            flexDirection: "column",
          }}
        >
          <div style={{ width: "100%", paddingBottom: 5, paddingTop: 50 }}>
            <div
              ref={dropdownRef}
              style={{ position: "relative", display: "flex" }}
            >
              <button
                onClick={() => {
                  const result = productDropDowns1.find(
                    (item) => item.id === item.productId
                  );
                  {
                    result.dropDownOrDialog === 1 ? (
                      <>{toggleDropdown()}</>
                    ) : (
                      <>
                        {setImageChoosed(result?.image)}
                        {setOpen2(true)}
                        {setProductChoosed(productDropDowns1)}
                        {setOBJOfProductChoosed(result)}
                      </>
                    );
                  }
                }}
                style={{
                  padding: "10px 20px",
                  backgroundColor: "white", //"#007bff",
                  color: "white",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent:
                    productDropDowns1.length > 1 ? "space-between" : "center",
                  width: "100%",
                  border:
                    productDropDowns1.length > 1
                      ? "1px solid #e4e4e7"
                      : "1px solid #18181b",
                  //border: "1px solid black",
                }}
              >
                <p style={{ color: "black", margin: 0 }}>{selectedOption}</p>
                <span
                  style={{
                    marginLeft: "10px",
                    display: "inline-block",
                    transition: "transform 0.3s ease", // Smooth transition for the rotation
                    transform: isOpen ? "rotate(180deg)" : "rotate(0deg)", // Rotate the arrow
                    color: "black",
                  }}
                >
                  {productDropDowns1.length > 1 ? (
                    <img
                      src={ArrowDown}
                      style={{
                        width: 12,
                        height: 12,
                        opacity: currentSlide === 0 ? 0.3 : 1,
                        cursor: currentSlide === 0 ? "" : "pointer",
                      }}
                    />
                  ) : (
                    <></>
                  )}
                </span>
              </button>
              <ul
                style={{
                  position: "absolute",
                  top: "100%",
                  left: "0",
                  backgroundColor: "white",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                  padding: "0",
                  margin: "0",
                  listStyleType: "none",
                  width: "100%",
                  maxHeight: isOpen ? "150px" : "0", // Set max height to limit the size of dropdown
                  overflowY: "auto", // Enable vertical scrolling when content overflows
                  opacity: isOpen ? "1" : "0", // Fade-in/out effect
                  transition: "all 0.3s ease", // Smooth transition for height and opacity
                }}
              >
                <style>
                  {`
                     /* Custom Scrollbar Styling */
                     ul::-webkit-scrollbar {
                       width: 8px;
                     }
                     ul::-webkit-scrollbar-thumb {
                       background-color: #c1c1c1; /* Scrollbar thumb color */
                       border-radius: 4px;
                     }
                     ul::-webkit-scrollbar-thumb:hover {
                       background-color: #a0a0a0; /* Scrollbar thumb hover color */
                     }
                     ul::-webkit-scrollbar-track {
                       background-color: #f1f1f1; /* Scrollbar track color */
                       border-radius: 4px;
                     }
                   `}
                </style>

                {productDropDowns1.length > 1 ? (
                  <>
                    {productDropDowns1.map((product) => (
                      <li
                        key={product.id}
                        style={{
                          padding: "10px 20px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleOptionClick(product.dropDown);
                          setTheDiscount(product.discount);
                          setPrice(product.price); // Example: Add 20 to the price
                          setPriceInsteadOf(product.priceInsteadOf); // Example: Add 20 to the price

                          setThedeal(product.theDeal);
                          setDiscount(
                            product.price -
                              (product.price * product.discount) / 100
                          );
                          setIdOfProduct(product.id);
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = "#f1f1f1";
                          sethoverTheDiscount(product.discount);
                          setHoverPrice(product.price); // Set the temporary hover price
                          setHoverPriceInsteadOf(product.priceInsteadOf);

                          setHoverThedeal(product.theDeal);
                          setHoverDiscount(
                            product.price -
                              (product.price * product.discount) / 100
                          );
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = "white";
                          sethoverTheDiscount(null);
                          setHoverPrice(null); // Reset to null to show the actual price
                          setHoverPriceInsteadOf(null);

                          setHoverThedeal(null);
                          setHoverDiscount(null);
                        }}
                      >
                        {product.dropDown}
                      </li>
                    ))}
                  </>
                ) : (
                  <></>
                )}
              </ul>
            </div>
          </div>
          <button
            style={{
              backgroundColor: "#27272a",
              color: "#fff",
              border: "none",
              padding: "10px 20px",
              cursor: "pointer",
              fontSize: "16px",
              width: "100%",
            }}
            onClick={() => {
              CreateProduct();
            }}
          >
            {t("profile.Buy")}
          </button>
        </div>
      </div>
    );
  }
}
